import {createActions} from 'client/framework';

const normalActions = ['UPDATE_INPUT', 'TOGGLE_TOP_FIVE'];

const freeEntryQuestionActions = createActions(null, normalActions);
export default freeEntryQuestionActions;
